import React from "react";
var __jsx = React.createElement;
import ScreenCard from "./ScreenCard";
import AnimatedCard from "@/pages/finance-eligibility/components/AnimatedCard";
import useIsMobile from "@hooks/useIsMobile";
var ScreenMainCard = function ScreenMainCard(_ref) {
  var screenData = _ref.screenData;
  var isMobile = useIsMobile();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 lg:gap-0"
  }, /*#__PURE__*/React.createElement("div", {
    role: "heading",
    "aria-level": 2
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-primary text-lg font-bold text-start lg:hidden"
  }, screenData === null || screenData === void 0 ? void 0 : screenData.main_title)), isMobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatedCard, {
    key: screenData === null || screenData === void 0 ? void 0 : screenData.key
  }, /*#__PURE__*/React.createElement(ScreenCard, {
    screenData: screenData
  }))) : /*#__PURE__*/React.createElement(ScreenCard, {
    screenData: screenData
  })));
};
export default ScreenMainCard;